export default __webpack_public_path__ + "static/media/alexa7.b5ddc071.webp";